export const swatchCSSVars = {
    color: `--fui-SwatchPicker--color`,
    borderColor: `--fui-SwatchPicker--borderColor`
};
